import type { DimensionModifierValue } from "schemas/generated/fileModifiers";
import type { DimensionMode } from "./DimensionSelector";

import React from "react";

import HeightModifier from "./HeightModifier";
import WidthModifier from "./WidthModifier";

interface ContainerSizeModifierProps {
  onWidthChange: (modifiers: DimensionModifierValue[]) => void;
  onHeightChange: (modifiers: DimensionModifierValue[]) => void;
  /** NOTE (Derek, 2026-01-14, REPL-20840): Options to exclude from the height dropdown (e.g., ["full"] to hide Fill option) */
  heightExcludeOptions?: DimensionMode[];
}

const ContainerSizeModifier: React.FC<ContainerSizeModifierProps> = ({
  onWidthChange,
  onHeightChange,
  heightExcludeOptions = [],
}) => {
  return (
    <div className="grid w-full grid-cols-2 gap-2">
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-2xs font-medium text-muted">Width</span>
        <WidthModifier onChange={onWidthChange} />
      </div>
      <div className="flex min-w-0 flex-col gap-1">
        <span className="text-2xs font-medium text-muted">Height</span>
        <HeightModifier
          onChange={onHeightChange}
          excludeOptions={heightExcludeOptions}
        />
      </div>
    </div>
  );
};

export default ContainerSizeModifier;
